import React from 'react'

const Major = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <defs>
      <path
        id="outline_svg__a"
        d="M21.167 5.333c.458 0 .833.375.833.834a.836.836 0 01-.833.833h-.834v3.333h.834c.458 0 .833.375.833.834v10a.836.836 0 01-.833.833H10.333A3.333 3.333 0 017 18.667v-10a3.334 3.334 0 013.333-3.334zm-12.5 6.204v7.13c0 .919.746 1.666 1.666 1.666h10V12h-10c-.61 0-1.175-.176-1.666-.463zM16.167 2c.458 0 .833.375.833.833a.836.836 0 01-.833.834h-.834V4.5h-1.666v-.833H5.333a1.667 1.667 0 000 3.333h1.185a4.15 4.15 0 00-.351 1.667h-.834c-.61 0-1.175-.176-1.666-.463v7.13c0 .919.746 1.666 1.666 1.666h.834v1.667h-.834A3.334 3.334 0 012 15.333v-10A3.334 3.334 0 015.333 2zm2.5 5h-8.334a1.667 1.667 0 000 3.333h8.334V7z"
      />
    </defs>
    <use fill={props.fill || '#1A344F'} fillRule="nonzero" xlinkHref="#outline_svg__a" />
  </svg>
)

export default Major
